import React, { useState } from 'react';
import NavBar from '../../components/Navbar/NavBar';
import Footer from '../../components/Footer';
import Card from '../../components/Cards/Card';
import Button from '../../components/button';
import friends from '../../data/friends';
import useDocTitle from '../../utils/useDocTitle';

const BoardOfFriends = () => {
  useDocTitle('Board of Friends');
  const [visibleCount, setVisibleCount] = useState(3);

  return (
    <>
      <div>
        <NavBar />
      </div>
      <div className="flex justify-center items-center mt-8 w-full bg-white py-12 lg:py-24">
        <div className="container mx-auto my-8 px-4 lg:px-20" data-aos="zoom-in">
          <h1 className="text-4xl font-bold text-blue-900 text-center mb-12">Board of Friends</h1>
          <div className="grid gap-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
            {friends.slice(0, visibleCount).map((friend, index) => (
              <Card
                key={index}
                id={friend.id}
                title={friend.title}
                description={friend.description}
                imgSrc={friend.imgSrc}
                linkText="View Profile"
                linkPath={friend.linkPath}
                borderColorClass="border-primary"
              />
            ))}
          </div>
          {visibleCount < friends.length && (
            <div className="flex justify-center mt-8">
              <Button
                onClick={() => setVisibleCount(visibleCount + 3)}
                text="View More"
                color="primary"
              />
            </div>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BoardOfFriends;